// src/components/cart/CartInitializer.tsx
import { useEffect } from 'react';
import { cartService } from '../../services/cartService';
import { useUser } from '@clerk/clerk-react';

/**
 * A simple component that initializes the cart
 * This can be added to the App component without any UI elements
 */
const CartInitializer: React.FC = () => {
  const { isSignedIn, user } = useUser();
  
  // Initialize cart and sync with FastSpring
  useEffect(() => {
    // Give FastSpring a moment to load
    const timer = setTimeout(() => {
      if (window.fastspring && window.fastspring.builder) {
        console.log('Initializing cart from localStorage');
        cartService.initializeCart();
      } else {
        console.log('FastSpring not available yet, will retry');
        // Try again in a second
        const retryTimer = setTimeout(() => {
          if (window.fastspring && window.fastspring.builder) {
            console.log('Initializing cart on retry');
            cartService.initializeCart();
          } else {
            console.warn('FastSpring still not available after retry');
          }
        }, 1000);
        
        return () => clearTimeout(retryTimer);
      }
    }, 500);
    
    return () => clearTimeout(timer);
  }, []);
  
  // Save user email when logged in
  useEffect(() => {
    if (isSignedIn && user?.primaryEmailAddress?.emailAddress) {
      const userEmail = user.primaryEmailAddress.emailAddress;
      console.log('Saving user email for FastSpring:', userEmail);
      cartService.saveCustomerEmail(userEmail);
    }
  }, [isSignedIn, user]);
  
  // This component doesn't render anything
  return null;
};

export default CartInitializer;